"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FtEditorControl = void 0;
const tslib_1 = require("tslib");
const Cookies = require("js-cookie");
const Base64_1 = require("../../../javascript/Base64");
const Utilities_1 = require("../../../javascript/Utilities");
require("../../LanguagePicker/LanguagePicker");
class FtEditorControl {
    constructor($container, ftObjectId) {
        this.m_pageSize = 50;
        let that = this;
        if (!ftObjectId)
            throw new Error(("ftObjectId parameter must not be undefined or empty."));
        that.m_guid = Utilities_1.synUtil.getGUID(true);
        that.m_ftObjectId = ftObjectId;
        that.m_ftGridId = "ftGrid_" + that.m_guid;
        that.m_langPickerDivId = "langPickerDiv_" + that.m_guid;
        that.m_$container = $container;
    }
    get BeginAjax() {
        return this.m_beginAjax;
    }
    set BeginAjax(beginAjax) {
        this.m_beginAjax = beginAjax;
    }
    get EndAjax() {
        return this.m_endAjax;
    }
    set EndAjax(endAjax) {
        this.m_endAjax = endAjax;
    }
    init() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let that = this;
            try {
                // let require = await that.ensureLess();
                require("./FtEditorControl.tmpl.less");
                let markup = require("./FtEditorControl.tmpl.html");
                let tmpl = kendo.template(markup);
                that.m_$container
                    .addClass("ftEditorControl")
                    .html(tmpl({ synUtil: Utilities_1.synUtil, langPickerDivId: that.m_langPickerDivId, gridId: that.m_ftGridId }));
                let schema = yield that.getSchema();
                that.m_curLangId = schema.userUILangId;
                // that.prepareColumns(schema);
                let dataSource = that.createGridDataSource(schema);
                if (schema.isLangDependent) {
                    //#region Language dropdown creation
                    $("#" + that.m_langPickerDivId)
                        .on("languageChanged", function (evt, language) {
                        that.m_curLangId = language.id;
                        that.m_ftGrid.dataSource.read();
                    })
                        .synLanguagePicker({ mode: 1, initialLangId: that.m_curLangId });
                    //#endregion Language dropdown creation
                }
                else
                    that.m_$container.addClass("noLangPane");
                //#region Grid creation
                // All operators currently possible for filtering
                let filterOperators = {
                    contains: Utilities_1.synUtil.Strings.getValue("dynpsearchdlgcontains", "contains"),
                    isnull: Utilities_1.synUtil.Strings.getValue("dynpsearchdlgisnotnull", "is not undefined"),
                    isnotnull: Utilities_1.synUtil.Strings.getValue("dynpsearchdlgisnull", "is undefined"),
                    eq: Utilities_1.synUtil.Strings.getValue("dynpsearchdlgequal", "="),
                    neq: Utilities_1.synUtil.Strings.getValue("dynpsearchdlgnotequal", "<>"),
                    lt: Utilities_1.synUtil.Strings.getValue("dynpsearchdlgsmaller", "<"),
                    lte: Utilities_1.synUtil.Strings.getValue("dynpsearchdlgsmallerequal", "<="),
                    gt: Utilities_1.synUtil.Strings.getValue("dynpsearchdlggreater", ">"),
                    gte: Utilities_1.synUtil.Strings.getValue("dynpsearchdlggreaterequal", ">=")
                };
                let cols = [];
                for (let prop in schema.columns) {
                    if (prop !== schema.langIdCol && prop !== schema.lastChangeDateCol
                        && prop !== schema.lastTranslateDateCol && prop !== schema.deletedCol) {
                        let col = $.extend({ field: prop, width: "120px" }, schema.columns[prop]);
                        if (col.field === "name")
                            col.width = "300px";
                        else {
                            if (col.actualType === "datetime")
                                col.width = "195px";
                            else if (prop === "hyperlink")
                                col.width = "220px";
                            else if (prop === schema.idCol) {
                                col.width = "120px";
                                col.locked = true;
                            }
                        }
                        col.filterable = { operators: {} };
                        col.filterable.operators[col.type] = {};
                        if (col.type === "number" || col.type === "date")
                            $.extend(col.filterable.operators[col.type], {
                                eq: filterOperators.eq,
                                neq: filterOperators.neq,
                                lt: filterOperators.lt,
                                lte: filterOperators.lte,
                                gt: filterOperators.gt,
                                gte: filterOperators.gte
                            });
                        else if (col.type === "boolean" || col.type === "string")
                            col.filterable.operators[col.type].eq = filterOperators.eq;
                        cols.push(col);
                    }
                }
                let colSort = function (a, b) {
                    let getColSortOrder = function (col) {
                        if (col.field === "id")
                            return -7;
                        else if (col.field === "pid")
                            return -6;
                        else if (col.field === "name")
                            return -5;
                        else if (col.field === "abstract")
                            return -4;
                        else if (col.field === "deletedwarning")
                            return -3;
                        else if (col.field === "code")
                            return -2;
                        else if (col.field === "comments")
                            return -1;
                        return 0;
                    };
                    let orderA = getColSortOrder(a);
                    let orderB = getColSortOrder(b);
                    return orderA < orderB ? -1 : orderA > orderB ? 1 : 0;
                };
                cols.sort(colSort);
                let setLastHourFilter = function (set) {
                    if (schema.lastChangeDateCol) {
                        let $filterButton = $("#" + that.m_ftGridId).find(".btn.filterButton");
                        if (set) {
                            dataSource.filter({
                                field: schema.lastChangeDateCol,
                                operator: "gte",
                                value: "#variable.currentdatetime#MINUS00-00-0000 01:00:00"
                            });
                            $filterButton.removeClass("noFilter").addClass("filter");
                        }
                        else {
                            // eslint-disable-next-line no-null/no-null
                            dataSource.filter(null);
                            $filterButton.removeClass("filter").addClass("noFilter");
                        }
                    }
                };
                that.m_ftGrid = $("#" + that.m_ftGridId).kendoGrid({
                    autoBind: true,
                    dataBound(e) {
                        // hide pager if only 1 page
                        if (this.dataSource.totalPages() > 1)
                            this.pager.element.show();
                        else
                            this.pager.element.hide();
                        // Force resize for correct element dimensions (Otherwise pager may be cut off)
                        that.m_ftGrid.resize(true);
                        if (schema.deletedCol) {
                            $.each(e.sender.items(), function (idx, item) {
                                let dataItem = that.m_ftGrid.dataItem(item);
                                if (dataItem[schema.deletedCol] === true) {
                                    $(item).addClass("ftDeletedRow");
                                    if (!schema.isView && $(item).closest(".k-grid-content-locked").length) {
                                        let id = dataItem[schema.idCol].toString();
                                        let editCell = $(item).children("td").first().html("");
                                        let btn = $("<button type='button' class='k-button undeleteButton'><i class='fa fa-undo' /></button>")
                                            .attr("data-ftentry", id)
                                            .on("click", function () {
                                            if (window.confirm(Utilities_1.synUtil.Strings.getValue("asksurerestoreftentry"))) {
                                                let ftEntryId = $(this).attr("data-ftentry");
                                                that.raiseBeginAjax();
                                                Utilities_1.synUtil.getAJAXData({
                                                    url: Utilities_1.synUtil.getWSUrl("ForeigntableEditor") + that.m_ftObjectId + "/undelete/" + that.encodeFtId(ftEntryId),
                                                    method: "POST",
                                                    cleanUp(data) {
                                                        that.raiseEndAjax();
                                                        that.m_ftGrid.dataSource.read();
                                                        that.m_ftGrid.refresh();
                                                    }
                                                });
                                            }
                                        })
                                            .appendTo(editCell);
                                    }
                                }
                            });
                        }
                    },
                    dataSource,
                    editable: {
                        mode: "inline",
                        confirmation: Utilities_1.synUtil.Strings.getValue("asksuredeleteftentry")
                    },
                    edit(e) {
                        e.container.find(".k-button")
                            .contents().filter(function () {
                            return (this.nodeType === 3);
                        }).remove();
                    },
                    filterable: {
                        extra: false,
                        messages: {
                            clear: Utilities_1.synUtil.Strings.getValue("synempty"),
                            filter: Utilities_1.synUtil.Strings.getValue("synfilter"),
                            info: Utilities_1.synUtil.Strings.getValue("menufilterlistctrlnew"),
                            isTrue: Utilities_1.synUtil.Strings.getValue("dynpbooltrue"),
                            isFalse: Utilities_1.synUtil.Strings.getValue("dynpboolfalse"),
                            and: Utilities_1.synUtil.Strings.getValue("dynpsearchdlgand"),
                            or: Utilities_1.synUtil.Strings.getValue("dynpsearchdlgor")
                        }
                    },
                    height: "100%",
                    pageable: {
                        messages: {
                            display: Utilities_1.synUtil.Strings.getValue("listdisplay"),
                            empty: Utilities_1.synUtil.Strings.getValue("listempty"),
                            page: Utilities_1.synUtil.Strings.getValue("listpage"),
                            of: Utilities_1.synUtil.Strings.getValue("listof"),
                            itemsPerPage: Utilities_1.synUtil.Strings.getValue("listitemsperpage"),
                            first: Utilities_1.synUtil.Strings.getValue("listfirstpage"),
                            previous: Utilities_1.synUtil.Strings.getValue("listpreviouspage"),
                            next: Utilities_1.synUtil.Strings.getValue("listnextpage"),
                            last: Utilities_1.synUtil.Strings.getValue("listlastpage"),
                            refresh: Utilities_1.synUtil.Strings.getValue("refresh"),
                        }
                    },
                    resizable: true,
                    save(e) {
                        if (schema.hyperlinkCol)
                            e.model[schema.hyperlinkCol] = Utilities_1.synUtil.addUrlScheme(e.model[schema.hyperlinkCol]);
                    },
                    scrollable: true,
                    selectable: "row",
                    sortable: { allowUnsort: true },
                    toolbar: kendo.template("<div class='toolbar' />"),
                    columns: $.merge(schema.isView ? [] : [
                        {
                            command: [{ name: "edit", text: "", }, { name: "destroy", text: "" }],
                            title: "&nbsp;",
                            width: "150px",
                            locked: true,
                            sortable: false
                        }
                    ], cols),
                }).data("kendoGrid");
                //#region Custom "Add" button for grid toolbar
                if (!schema.isView) {
                    let a = $("<button type='button' />").addClass("k-button k-button-icontext")
                        .attr("href", "#")
                        .text(Utilities_1.synUtil.Strings.getValue("menunew"))
                        .on("click", function () {
                        require.ensure(["./FtEditorControl_NewEntry.tmpl.less"], function (require) {
                            let templateLess = require("./FtEditorControl_NewEntry.tmpl.less");
                            let newEntryMarkup = require("./FtEditorControl_NewEntry.tmpl.html");
                            //#region "Add Entry" window creation
                            that.raiseBeginAjax();
                            Utilities_1.synUtil.getAJAXData({
                                url: Utilities_1.synUtil.getWSUrl("ForeigntableEditor") + that.m_ftObjectId + "/rowTemplate/",
                                done(rowTemplate) {
                                    let langTemplates = {};
                                    langTemplates[Cookies.get("defLangId")] = $.extend({}, rowTemplate);
                                    let wndDataNew = Utilities_1.synUtil.popupWindow({
                                        title: Utilities_1.synUtil.Strings.getValue("menunew"),
                                        actions: ["Maximize", "Close"],
                                        width: 800,
                                        height: 600,
                                        modal: true
                                    });
                                    let idDataNew = {
                                        synUtil: Utilities_1.synUtil,
                                        windowId: "popup_" + wndDataNew.guid,
                                        buttonPaneId: "buttonPane_" + wndDataNew.guid,
                                        fieldListId: "fieldList_" + wndDataNew.guid,
                                        okButtonId: "okButton_" + wndDataNew.guid,
                                        cancelButtonId: "cancelButton_" + wndDataNew.guid,
                                        langPickerId: "langPickerId" + wndDataNew.guid,
                                        multiLang: schema.isLangDependent,
                                    };
                                    let templNew = kendo.template(newEntryMarkup);
                                    wndDataNew.contentDiv.html(templNew(idDataNew));
                                    // Create form
                                    let newCols = [];
                                    for (let prop in schema.columns) {
                                        let currentCol = schema.columns[prop];
                                        if (schema.deletedCol === prop || schema.langIdCol === prop
                                            || schema.lastChangeDateCol === prop || schema.lastTranslateDateCol === prop) {
                                            continue;
                                        }
                                        newCols.push($.extend({}, currentCol, { field: prop }));
                                    }
                                    newCols.sort(colSort);
                                    let validator = $("#" + idDataNew.fieldListId).kendoValidator({
                                        validate() {
                                            // Style fix for invalid numeric textboxes
                                            $("#" + idDataNew.fieldListId).find(".k-input.k-invalid").each(function (idx, elem) {
                                                let $elem = $(elem);
                                                let $numericWrap = $elem.parent(".k-numeric-wrap");
                                                if ($numericWrap.length) {
                                                    $numericWrap.children(".k-formatted-value").addClass("k-invalid");
                                                }
                                            });
                                        }
                                    }).data("kendoValidator");
                                    let createForm = function (langId) {
                                        let isDefLang = langId === Cookies.get("defLangId");
                                        let appendControl = function (li, col) {
                                            let commonAttrs = {
                                                "id": "ctrl_" + col.field + "_" + idDataNew.windowId,
                                            };
                                            if (!col.nullable && col.type !== "boolean") {
                                                commonAttrs.name = col.field;
                                                commonAttrs.required = "required";
                                                commonAttrs.validationMessage = Utilities_1.synUtil.Strings.getValue("synentervalue");
                                            }
                                            let fieldVal = langTemplates[langId][col.field];
                                            let synchronizeForAllLanguages = function (fieldName, value) {
                                                if (fieldName === schema.idCol || fieldName === schema.abstractCol
                                                    || fieldName === schema.codeCol || fieldName === schema.deletedWarningCol
                                                    || fieldName === schema.pidCol) {
                                                    for (let prop in langTemplates) {
                                                        langTemplates[prop][fieldName] = value;
                                                    }
                                                }
                                            };
                                            let showDefLangValueIfDifferent = function (field, langId, val, $defLangVal) {
                                                let defLang = Cookies.get("defLangId");
                                                if (langId !== defLang) {
                                                    if (langTemplates[defLang][field] !== val)
                                                        $defLangVal.css("display", "");
                                                    else
                                                        $defLangVal.css("display", "none");
                                                }
                                            };
                                            if (col.actualType === "time") {
                                                $("<input  />").attr(commonAttrs).appendTo(li)
                                                    .kendoTimePicker({
                                                    format: "T",
                                                    change() {
                                                        let val = Utilities_1.synUtil.timeToJson(this.value());
                                                        langTemplates[langId][col.field] = val;
                                                        synchronizeForAllLanguages(col.field, val);
                                                        showDefLangValueIfDifferent(col.field, langId, val, this.wrapper.next(".defLangValue"));
                                                    }
                                                }).data("kendoTimePicker").value(Utilities_1.synUtil.jsonToTime(fieldVal));
                                            }
                                            else if (col.actualType === "datetime") {
                                                $("<input  />").attr(commonAttrs).appendTo(li)
                                                    .kendoDateTimePicker({
                                                    format: "G",
                                                    change() {
                                                        let val = Utilities_1.synUtil.dateTimeToJson(this.value());
                                                        langTemplates[langId][col.field] = val;
                                                        synchronizeForAllLanguages(col.field, val);
                                                        showDefLangValueIfDifferent(col.field, langId, val, this.wrapper.next(".defLangValue"));
                                                    }
                                                }).data("kendoDateTimePicker").value(Utilities_1.synUtil.jsonToDateTime(fieldVal));
                                            }
                                            else if (col.actualType === "date") {
                                                $("<input  />").attr(commonAttrs).appendTo(li)
                                                    .kendoDatePicker({
                                                    format: "d",
                                                    change() {
                                                        let val = Utilities_1.synUtil.dateToJson(this.value());
                                                        langTemplates[langId][col.field] = val;
                                                        synchronizeForAllLanguages(col.field, val);
                                                        showDefLangValueIfDifferent(col.field, langId, val, this.wrapper.next(".defLangValue"));
                                                    }
                                                }).data("kendoDatePicker").value(Utilities_1.synUtil.jsonToDate(fieldVal));
                                            }
                                            else if (col.actualType === "boolean") {
                                                $("<input type='checkbox' class='k-checkbox' />")
                                                    .prop("checked", fieldVal)
                                                    .change(function () {
                                                    let val = $(this).prop("checked");
                                                    langTemplates[langId][col.field] = val;
                                                    synchronizeForAllLanguages(col.field, val);
                                                    showDefLangValueIfDifferent(col.field, langId, val, $(this).next(".defLangValue"));
                                                })
                                                    .attr(commonAttrs).appendTo(li);
                                            }
                                            else if (col.actualType === "int" || col.actualType === "bigint") {
                                                let numBox = $("<input  type='number' />").attr(commonAttrs)
                                                    .appendTo(li).kendoNumericTextBox({
                                                    format: "#",
                                                    change() {
                                                        let val = this.value();
                                                        langTemplates[langId][col.field] = val;
                                                        synchronizeForAllLanguages(col.field, val);
                                                        showDefLangValueIfDifferent(col.field, langId, val, this.wrapper.next(".defLangValue"));
                                                    }
                                                }).data("kendoNumericTextBox");
                                                numBox.value(fieldVal);
                                                if (col.field === "id" && rowTemplate["id"] != undefined)
                                                    numBox.min(rowTemplate["id"]);
                                            }
                                            else if (col.actualType === "float") {
                                                $("<input  type='number' />").attr(commonAttrs)
                                                    .appendTo(li).kendoNumericTextBox({
                                                    format: "n2",
                                                    change() {
                                                        let val = this.value();
                                                        langTemplates[langId][col.field] = val;
                                                        synchronizeForAllLanguages(col.field, val);
                                                        showDefLangValueIfDifferent(col.field, langId, val, this.wrapper.next(".defLangValue"));
                                                    }
                                                })
                                                    .data("kendoNumericTextBox").value(fieldVal);
                                            }
                                            else {
                                                $("<input type='textbox' class='k-textbox'  />")
                                                    .attr(commonAttrs)
                                                    .change(function () {
                                                    let val = $(this).val();
                                                    langTemplates[langId][col.field] = val;
                                                    synchronizeForAllLanguages(col.field, val);
                                                    showDefLangValueIfDifferent(col.field, langId, val, $(this).next(".defLangValue"));
                                                })
                                                    .val(fieldVal)
                                                    .appendTo(li);
                                            }
                                        };
                                        kendo.destroy($("#" + idDataNew.fieldListId));
                                        $("#" + idDataNew.fieldListId).html("");
                                        $.each(newCols, function (idx, col) {
                                            let li = $("<li />").appendTo($("#" + idDataNew.fieldListId));
                                            let label = $("<label for='" + "ctrl_" + col.field + "_" + idDataNew.windowId + "' />")
                                                .text(col.field).appendTo(li);
                                            if (!col.nullable)
                                                label.addClass("required");
                                            appendControl(li, col);
                                            if (!isDefLang) {
                                                let def = $("#" + idDataNew.langPickerId).synLanguagePicker("getLanguage", Cookies.get("defLangId"));
                                                let defLangVal = langTemplates[Cookies.get("defLangId")][col.field], defLangValFmt = defLangVal;
                                                if (col.type === "boolean")
                                                    defLangValFmt = defLangVal ? "Y" : "N";
                                                let fmt = "";
                                                if (defLangVal != undefined) {
                                                    if (col.type === "time")
                                                        fmt = ":T";
                                                    else if (col.type === "date")
                                                        fmt = ":d";
                                                    else if (col.type === "datetime")
                                                        fmt = ":G";
                                                    else if (col.type === "float")
                                                        fmt = ":n2";
                                                    else if (col.type === "int" || col.type === "bigint")
                                                        fmt = "#";
                                                }
                                                else
                                                    defLangValFmt = "-";
                                                $("<div class='defLangValue' />")
                                                    .text(kendo.format("({0}: {1" + fmt + "})", def.code.toUpperCase(), defLangValFmt))
                                                    .css("display", (defLangVal !== langTemplates[langId][col.field]) ? "" : "none")
                                                    .appendTo(li);
                                            }
                                        });
                                        $("#" + idDataNew.fieldListId).find("input").each(function (idx, elem) {
                                            let $elem = $(elem);
                                            let isRequired = typeof $elem.attr("required") !== "undefined";
                                            if (isRequired && $elem.parent().is(".k-numeric-wrap")) {
                                                $elem.data("kendoNumericTextBox").bind("spin", function () {
                                                    validator.validateInput($(this.element));
                                                });
                                            }
                                            $elem.on("blur change keyup paste", function () {
                                                if (typeof $(this).attr("required") !== "undefined" && $(this).parent().is(".k-numeric-wrap")) {
                                                    if (!validator.validateInput($(this)))
                                                        $(this).parent().children(".k-formatted-value").addClass("k-invalid");
                                                    else
                                                        $(this).parent().children(".k-formatted-value").removeClass("k-invalid");
                                                }
                                                let valid = validator.validate();
                                                if (schema.isLangDependent)
                                                    $("#" + idDataNew.langPickerId).synLanguagePicker("enableLangIds", valid);
                                            });
                                        });
                                        validator.validate();
                                    };
                                    createForm(Cookies.get("defLangId"));
                                    // Create language picker
                                    if (schema.isLangDependent) {
                                        $("#" + idDataNew.langPickerId)
                                            .on("initSuccess", function () {
                                            $("#" + idDataNew.langPickerId).synLanguagePicker("enableLangIds", false);
                                        })
                                            .on("beforeLanguageChanged", function (evt, lang) {
                                            if (!validator.validate())
                                                evt.preventDefault();
                                        })
                                            .on("languageChanged", function (evt, lang) {
                                            if (typeof langTemplates[lang.id] === "undefined")
                                                langTemplates[lang.id] = $.extend({}, langTemplates[Cookies.get("defLangId")]);
                                            createForm(lang.id);
                                        })
                                            .synLanguagePicker({
                                            mode: 1,
                                            initialLangId: Cookies.get("defLangId")
                                        });
                                    }
                                    $("#" + idDataNew.cancelButtonId).on("click", function () {
                                        $("#" + idDataNew.windowId).data("kendoWindow").close();
                                    });
                                    $("#" + idDataNew.okButtonId).on("click", function () {
                                        if (validator.validate()) {
                                            Utilities_1.synUtil.beginAjaxProgress($("#" + idDataNew.okButtonId));
                                            let entries = [];
                                            for (let prop in langTemplates) {
                                                let ftEntry = $.extend({}, langTemplates[prop]);
                                                if (schema.isLangDependent)
                                                    ftEntry[schema.langIdCol] = parseInt(prop, 10);
                                                entries.push(ftEntry);
                                            }
                                            Utilities_1.synUtil.getAJAXData({
                                                method: "POST",
                                                url: Utilities_1.synUtil.getWSUrl("ForeigntableEditor") + that.m_ftObjectId + "/",
                                                requestData: JSON.stringify(entries),
                                                done() {
                                                    $("#" + idDataNew.windowId).data("kendoWindow").close();
                                                    if (schema.lastChangeDateCol)
                                                        setLastHourFilter(true);
                                                    else {
                                                        let curFilter = dataSource.filter();
                                                        if (curFilter)
                                                            dataSource.filter(undefined);
                                                        else {
                                                            dataSource.read();
                                                            that.m_ftGrid.refresh();
                                                        }
                                                    }
                                                },
                                                cleanUp() {
                                                    Utilities_1.synUtil.endAjaxProgress($("#" + idDataNew.okButtonId));
                                                }
                                            });
                                        }
                                    });
                                },
                                cleanUp: () => { that.raiseEndAjax(); }
                            });
                            //#endregion "Add Entry" window creation
                        });
                    }).appendTo($("#" + that.m_ftGridId).find("div.toolbar"));
                }
                //#endregion Custom "Add" button for grid toolbar
                //#region Custom Filter buttons
                if (schema.lastChangeDateCol) {
                    let filterButton = $("<button type='button' class='btn filterButton noFilter' />")
                        .attr("href", "#")
                        .text(Utilities_1.synUtil.Strings.getValue("synchangedwithinlasthour"))
                        .on("click", function () {
                        setLastHourFilter($(this).hasClass("noFilter"));
                    }).appendTo($("#" + that.m_ftGridId).find("div.toolbar"));
                    if (dataSource.lastHourFilter === true)
                        filterButton.addClass("enabled");
                }
                //#endregion Custom Filter buttons
                //#endregion Grid creation
            }
            catch (err) {
                "Method not implemented.";
            }
        });
    }
    destroy() {
        if (this.m_ftGrid)
            this.m_ftGrid.destroy();
    }
    unlock() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let that = this;
            return new Promise((resolve, reject) => {
                that.raiseBeginAjax();
                Utilities_1.synUtil.getAJAXData({
                    url: Utilities_1.synUtil.getWSUrl("ForeigntableEditor") + that.m_ftObjectId + "/unlock/",
                    method: "POST",
                    done: () => resolve(),
                    fail: (jqXHR, textStatus, errorThrown, url) => {
                        Utilities_1.synUtil.getAJAXDataFail(jqXHR, textStatus, errorThrown, url);
                        reject("Error unlocking FT: " + that.m_ftObjectId);
                    },
                    cleanUp: () => {
                        that.raiseEndAjax();
                    }
                });
            });
        });
    }
    getSchema() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let that = this;
            return new Promise((resolve, reject) => {
                that.raiseBeginAjax();
                Utilities_1.synUtil.getAJAXData({
                    url: Utilities_1.synUtil.getWSUrl("ForeigntableEditor") + that.m_ftObjectId + "/schema/",
                    done: (schema) => {
                        that.prepareColumns(schema);
                        resolve(schema);
                    },
                    fail: (jqXHR, textStatus, errorThrown, url) => {
                        Utilities_1.synUtil.getAJAXDataFail(jqXHR, textStatus, errorThrown, url);
                        reject("Error getting schema for " + that.m_ftObjectId);
                    },
                    cleanUp: () => {
                        that.raiseEndAjax();
                    }
                });
            });
        });
    }
    raiseBeginAjax() {
        let callback = this.m_beginAjax;
        if (callback)
            callback();
    }
    raiseEndAjax() {
        let callback = this.m_endAjax;
        if (callback)
            callback();
    }
    // This encoding is necessary for free-form unicode IDs. Otherwise ids
    // such as "<>,;.:-_#'" would not work (the hash is interpreted as fragment identifier even
    // with encodeURIComponent and does not reach the web service).
    encodeFtId(id) {
        return encodeURIComponent(Base64_1.Base64.encode(id));
    }
    getPage(schema, pageNum, pageSize, filter /*tbd*/, sort) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let that = this;
            return new Promise((resolve, reject) => {
                let synFilter = {};
                if (filter)
                    $.each(filter.filters, (idx, curFilter) => {
                        synFilter[curFilter.field] = that.convertOp(curFilter.operator) + that.convertValue(schema, curFilter.field, curFilter.value);
                    });
                let requestData = {
                    pageNum,
                    pageSize,
                    langId: parseInt(that.m_curLangId, 10),
                    filter: synFilter
                };
                if (sort === null || sort === void 0 ? void 0 : sort.length) {
                    requestData.sortColumn = sort[0].field;
                    requestData.sortDirection = sort[0].dir.toUpperCase();
                }
                that.raiseBeginAjax();
                Utilities_1.synUtil.getAJAXData({
                    url: Utilities_1.synUtil.getWSUrl("ForeigntableEditor") + that.m_ftObjectId + "/page/",
                    method: "POST",
                    requestData: JSON.stringify(requestData),
                    done: (result) => {
                        $.each(result.data, (idx, row) => {
                            for (let prop in row) {
                                if (row.hasOwnProperty(prop) && schema.columns.hasOwnProperty(prop)) {
                                    if (schema.columns[prop].actualType === "dateTime")
                                        row[prop] = Utilities_1.synUtil.jsonToDateTime(row[prop]);
                                    else if (schema.columns[prop].actualType === "time")
                                        row[prop] = Utilities_1.synUtil.jsonToTime(row[prop]);
                                    else if (schema.columns[prop].actualType === "date")
                                        row[prop] = Utilities_1.synUtil.jsonToDate(row[prop]);
                                }
                            }
                        });
                        resolve(result);
                    },
                    fail: (jqXHR, textStatus, errorThrown, url) => {
                        reject(errorThrown);
                        Utilities_1.synUtil.getAJAXDataFail(jqXHR, textStatus, errorThrown, url);
                    },
                    cleanUp: () => { that.raiseEndAjax(); }
                });
            });
        });
    }
    createGridDataSource(schema) {
        let that = this;
        return new kendo.data.DataSource({
            transport: {
                read: (options) => {
                    let promise = that.getPage(schema, options.data.page - 1, options.data.pageSize, options.data.filter, options.data.sort);
                    promise.then((result) => {
                        options.success(result);
                    });
                    promise.catch((err) => {
                        options.error(err);
                    });
                },
                update(options) {
                    let ds = that.m_ftGrid.dataSource;
                    let ftEditorChangeUrl = Utilities_1.synUtil.getWSUrl("ForeigntableEditor") + that.m_ftObjectId + "/change/";
                    that.raiseBeginAjax();
                    Utilities_1.synUtil.getAJAXData({
                        url: ftEditorChangeUrl,
                        method: "POST",
                        requestData: JSON.stringify({
                            langId: parseInt(that.m_curLangId, 10),
                            entry: that.serializeFtEntry(options.data, schema)
                        }),
                        done(result) {
                            options.success(result);
                            ds.read();
                            that.m_ftGrid.refresh();
                        },
                        fail(jqXHR, textStatus, errorThrown, url) {
                            options.error(errorThrown);
                            Utilities_1.synUtil.getAJAXDataFail(jqXHR, textStatus, errorThrown, ftEditorChangeUrl);
                        },
                        cleanUp: () => { that.raiseEndAjax(); }
                    });
                },
                destroy(options) {
                    // Cancel changes here because removal might only affect deleted column.
                    // Otherwise the whole row is visually removed from the grid.
                    // Visual row must be updated manually afterwards.
                    let ds = that.m_ftGrid.dataSource;
                    ds.cancelChanges();
                    let delId = options.data.id.toString();
                    let doDelete = function (id, success) {
                        Utilities_1.synUtil.getAJAXData({
                            url: Utilities_1.synUtil.getWSUrl("ForeigntableEditor") + that.m_ftObjectId + "/" + that.encodeFtId(id),
                            method: "DELETE",
                            done(data) {
                                success(data);
                                ds.read();
                                that.m_ftGrid.refresh();
                            }
                        });
                    };
                    that.raiseBeginAjax();
                    Utilities_1.synUtil.getAJAXData({
                        url: Utilities_1.synUtil.getWSUrl("ForeigntableEditor") + "canDelete/" + that.m_ftObjectId + "/" + that.encodeFtId(delId) + "/",
                        method: "GET",
                        done(canDelete) {
                            if (canDelete === true || window.confirm(Utilities_1.synUtil.Strings.getValue("asksuredeleteftentryreferenced"))) {
                                doDelete(delId, options.success);
                            }
                        },
                        cleanUp: () => { that.raiseEndAjax(); }
                    });
                },
            },
            serverFiltering: true,
            serverPaging: true,
            serverSorting: true,
            pageSize: that.m_pageSize,
            schema: {
                data: "data",
                total: "total",
                model: {
                    id: schema.idCol,
                    fields: schema.columns
                }
            }
        });
    }
    // custom parsing for date/time/datetime fields
    getKendoAttrs(field) {
        return {
            "data-text-field": field,
            "data-value-field": field,
            "data-bind": "value:" + field
        };
    }
    prepareColumns(schema) {
        let that = this;
        for (let prop in schema.columns) {
            let currentCol = schema.columns[prop];
            currentCol.actualType = (" " + currentCol.type).slice(1);
            currentCol.prop = prop;
            currentCol.editable = function () {
                if (schema.isView || schema.idCol === this.prop || schema.deletedCol === this.prop
                    || schema.langIdCol === this.prop || schema.lastChangeDateCol === this.prop
                    || schema.lastTranslateDateCol === this.prop) {
                    return false;
                }
                else
                    return true;
            };
            if (currentCol.type === "date") {
                // currentCol.parse = synUtil.jsonToDate;
                currentCol.format = "{0:d}";
                currentCol.editor = function (container, options) {
                    $("<input />")
                        .attr(that.getKendoAttrs(options.field))
                        .appendTo(container)
                        .kendoDatePicker({
                        format: "d",
                        change() {
                            options.model[options.field] = this.value();
                        }
                    });
                };
            }
            else if (currentCol.type === "time") {
                // currentCol.parse = synUtil.jsonToTime;
                currentCol.format = "{0:T}";
                currentCol.type = "date";
                currentCol.editor = function (container, options) {
                    $("<input />")
                        .attr(that.getKendoAttrs(options.field))
                        .appendTo(container)
                        .kendoTimePicker({
                        format: "T",
                        change() {
                            options.model[options.field] = this.value();
                        }
                    });
                };
            }
            else if (currentCol.type === "datetime") {
                // currentCol.parse = synUtil.jsonToDateTime;
                currentCol.format = "{0:G}";
                currentCol.type = "date";
                currentCol.editor = function (container, options) {
                    $("<input />")
                        .attr(that.getKendoAttrs(options.field))
                        .appendTo(container)
                        .kendoDateTimePicker({
                        format: "G",
                        change() {
                            options.model[options.field] = this.value();
                        }
                    });
                };
            }
            else if (currentCol.type === "int" || currentCol.type === "bigint") {
                currentCol.type = "number";
                currentCol.format = "{0:#}";
            }
            else if (currentCol.type === "float") {
                currentCol.type = "number";
                currentCol.editor = function (container, options) {
                    $("<input />")
                        .attr(that.getKendoAttrs(options.field))
                        .appendTo(container)
                        .kendoNumericTextBox({
                        format: "n2",
                        value: options.model[options.field],
                        min: Number.MIN_VALUE,
                        max: Number.MAX_VALUE,
                        spinners: false,
                        change() {
                            options.model[options.field] = this.value();
                        }
                    });
                };
            }
            else if (currentCol.type === "boolean")
                currentCol.template = "#= " + prop + "? '<i class=\\'fa fa-check\\' style=\\'display:block;text-align:center;\\' />' : '' #";
            else if (prop === "hyperlink") {
                // currentCol.template = "<a href='#=hyperlink#' target='_blank' rel='noopener noreferrer'>#=hyperlink#</a>";
                currentCol.template = "#=data.hyperlink? '<a href=\"'+data.hyperlink+'\" target=\"_blank\" rel=\"noopener noreferrer\" >'+data.hyperlink+'</a>' : ''#";
            }
            if (prop === schema.idCol) {
                currentCol.template = "<div style='font-weight: bold;"
                    + (schema.columns[schema.idCol].type === "number" ? "text-align: center;" : "")
                    + "' title='#if(data.NeedsTranslation__) {# " +
                    Utilities_1.synUtil.Strings.getValue("synftentryneedstranslation")
                    + " #}#'>"
                    + "#:" + prop + "#"
                    + "# if(data.NeedsTranslation__) {# <i class='fa fa-exclamation-triangle' /> #}#"
                    + "</div>";
            }
        }
    }
    convertOp(kendoOp) {
        if (kendoOp === "neq")
            return "<>";
        else if (kendoOp === "isnull" || kendoOp === "isnotnull")
            return kendoOp.toUpperCase();
        else if (kendoOp === "lt")
            return "<";
        else if (kendoOp === "lte")
            return "<=";
        else if (kendoOp === "gt")
            return ">";
        else if (kendoOp === "gte")
            return ">=";
        else if (kendoOp === "isempty")
            return "ISNULL";
        else if (kendoOp === "isnotempty")
            return "ISNOTNULL";
        return "";
    }
    serializeFtEntry(dataItem, schema) {
        let serialized = {};
        for (let prop in dataItem) {
            if (dataItem.hasOwnProperty(prop) && schema.columns.hasOwnProperty(prop)) {
                let val = dataItem[prop];
                let currentCol = schema.columns[prop];
                if (currentCol.actualType === "date")
                    val = Utilities_1.synUtil.dateToJson(val);
                else if (currentCol.actualType === "time")
                    val = Utilities_1.synUtil.timeToJson(val);
                else if (currentCol.actualType === "datetime")
                    val = Utilities_1.synUtil.dateTimeToJson(val);
                serialized[prop] = val;
            }
        }
        return serialized;
    }
    escapeFilterValue(input) {
        if (!input)
            return "";
        // string might start with a variable, this variable must not be escaped
        let startIdx = 0;
        let variableRegex = /^#variable.[a-z0-9\.]+#/;
        let matches = variableRegex.exec(input);
        if (matches != undefined)
            startIdx = matches[0].length;
        let result = "";
        for (let i = input.length - 1; i >= startIdx; i--) {
            let c = input[i];
            result = c + result;
            if ("<|\\&>#".indexOf(c) >= 0
                || result.indexOf("ISNULL") === 0
                || result.indexOf("ISNOTNULL") === 0)
                result = "\\" + result;
        }
        if (startIdx > 0)
            result = input.substring(0, startIdx) + result;
        return result;
    }
    convertValue(schema, colName, colValue) {
        if (/^#variable.[a-z0-9\.]+#/.test(colValue))
            return colValue;
        let type = schema.columns[colName].actualType;
        if (type === "boolean")
            return colValue ? "Y" : "N";
        else if (type === "date" || type === "datetime" || type === "time")
            return kendo.toString(colValue, schema.dateTimeFormat);
        else if (type === "string")
            return this.escapeFilterValue(colValue);
        return colValue.toString();
    }
}
exports.FtEditorControl = FtEditorControl;
